export const localeUppy: any = {};

export default {};

localeUppy.strings = {
  addMoreFiles: 'Tambah berkas lainnya',
  addingMoreFiles: 'Menambahkan berkas lainnya',
  allowAccessDescription:
    'Untuk mengambil gambar atau merekam video dengan kamera Anda, mohon izinkan akses kamera untuk situs ini.',
  allowAccessTitle: 'Mohon izinkan akses ke kamera Anda',
  authenticateWith: 'Menghubungkan ke %{pluginName}',
  authenticateWithTitle:
    'Mohon autentikasi dengan %{pluginName} untuk memilih berkas',
  back: 'Kembali',
  browse: 'cari',
  cancel: 'Batal',
  cancelUpload: 'Batal upload',
  chooseFiles: 'Memilih berkas',
  closeModal: 'Tutup popup',
  companionAuthError: 'Membutuhkan otorisasi',
  companionError: 'Gagal menghubungkan dengan Companion',
  complete: 'Berhasil',
  connectedToInternet: 'Menghubungkan dengan internet',
  copyLink: 'Salin link',
  copyLinkToClipboardFallback: 'Salin URL dibawah',
  copyLinkToClipboardSuccess: 'Link telah disalin ke papan klip',
  creatingAssembly: 'Bersiap mengunggah...',
  creatingAssemblyFailed: 'Transloadit: Tidak dapat membuat Assembly',
  dashboardTitle: 'Unggahan File',
  dashboardWindowTitle: 'Bagian Unggah Berkas (Tekan escape untuk menutup)',
  dataUploadedOfTotal: '%{complete} dari %{total}',
  done: 'Berhasil',
  dropHereOr: 'Jatuhkan berkas disini atau %{browse}',
  dropHint: 'Jatuhkan berkas anda disini',
  dropPaste:
    'Jatuhkan berkas disini untuk unggah, atau %{browse} file dari komputer',
  dropPasteImport: 'Jatuhkan berkas disini, salin, %{browse} atau impor dari',
  edit: 'Ubah',
  editFile: 'Ubah berkas',
  editing: 'Mengubah %{file}',
  emptyFolderAdded: 'Tidak ada berkas yang ditambahkan dari folder kosong',
  encoding: 'Sedang encode berkas...',
  enterCorrectUrl:
    'URL tidak benar: Pastikan Anda memasukkan tautan langsung ke file',
  enterUrlToImport: 'Massukkan URL untuk impor berkas',
  exceedsSize: 'Berkass ini melebihi ukuran maksimum yang dibolehkan dari',
  failedToFetch:
    'Companion gagal mengambil url ini, mohon pastikan sudah benar',
  failedToUpload: 'Gagal mengunggah %{file}',
  fileSource: 'Sumber file: %{name}',
  filesUploadedOfTotal: {
    '0': '%{complete} dari %{smart_count} berkas terunggah',
    '1': '%{complete} dari %{smart_count} berkas terunggah',
    '2': '%{complete} dari %{smart_count} berkas terunggah'
  },
  filter: 'Saringan',
  finishEditingFile: 'Berhasil menyunting berkas',
  folderAdded: {
    '0': 'Berhasil menambahkan %{smart_count} berkas dari %{folder}',
    '1': 'Berhasil menambahkan %{smart_count} berkas dari %{folder}',
    '2': 'Berhasil menambahkan %{smart_count} berkas dari %{folder}'
  },
  import: 'Impor',
  importFrom: 'Impor dari %{name}',
  link: 'Link',
  loading: 'Memuat...',
  logOut: 'Keluar',
  myDevice: 'Perangkat saya',
  noFilesFound: 'Tidak ada berkas ditemukan',
  noInternetConnection: 'Tidak ada koneksi internet',
  pause: 'Jeda',
  pauseUpload: 'Jeda unggahan',
  paused: 'Terjeda',
  poweredBy: 'Powered by',
  preparingUpload: 'Menyiapkan unggahan...',
  processingXFiles: {
    '0': 'Memprosess %{smart_count} berkas',
    '1': 'Memprosess %{smart_count} berkas',
    '2': 'Memprosess %{smart_count} berkas'
  },
  removeFile: 'Cabut berkas',
  resetFilter: 'Atur ulang saringan',
  resume: 'Lanjutkan',
  resumeUpload: 'Lanjutkan mengunggah',
  retry: 'Ulangi',
  retryUpload: 'Ulangi mengunggah',
  saveChanges: 'Simpan perubahan',
  selectXFiles: {
    '0': 'Memilih %{smart_count} berkas',
    '1': 'Memilih %{smart_count} berkas',
    '2': 'Memilih %{smart_count} berkas'
  },
  smile: 'Senyum!',
  startRecording: 'Memulai merekam video',
  stopRecording: 'Berhenti merekam video',
  takePicture: 'Ambil gambar',
  timedOut: 'Mengunggah berhenti untuk %{seconds} detik, batalkan.',
  upload: 'Mengunggah',
  uploadComplete: 'Mengunggah berhasil',
  uploadFailed: 'Gagal mengunggah',
  uploadPaused: 'Mengunggah terjeda',
  uploadXFiles: {
    '0': 'Mengunggah %{smart_count} berkas',
    '1': 'Mengunggah %{smart_count} berkas',
    '2': 'Mengunggah %{smart_count} berkas'
  },
  uploadXNewFiles: {
    '0': 'Mengunggah +%{smart_count} berkas',
    '1': 'Mengunggah +%{smart_count} berkas',
    '2': 'Mengunggah +%{smart_count} berkas'
  },
  uploading: 'Mengunggah',
  uploadingXFiles: {
    '0': 'Mengunggah %{smart_count} berkas',
    '1': 'Mengunggah %{smart_count} berkas',
    '2': 'Mengunggah %{smart_count} berkas'
  },
  xFilesSelected: {
    '0': '%{smart_count} berkas dipilih',
    '1': '%{smart_count} berkas dipilih',
    '2': '%{smart_count} berkas dipilih'
  },
  xMoreFilesAdded: {
    '0': '%{smart_count} berkas ditambahkan',
    '1': '%{smart_count} berkas ditambahkan',
    '2': '%{smart_count} berkas ditambahkan'
  },
  xTimeLeft: '%{time} left',
  youCanOnlyUploadFileTypes: 'Hanya dapat mengunggah: %{types}',
  youCanOnlyUploadX: {
    '0': 'Hanya dapat mengunggah %{smart_count} berkas',
    '1': 'Hanya dapat mengunggah %{smart_count} berkas',
    '2': 'Hanya dapat mengunggah %{smart_count} berkas'
  },
  youHaveToAtLeastSelectX: {
    '0': 'Silahkan memilih setidaknya %{smart_count} berkas',
    '1': 'Silahkan memilih setidaknya %{smart_count} berkas',
    '2': 'Silahkan memilih setidaknya %{smart_count} berkas'
  }
};
